export default {
	styleOverrides: {
		root: ({ ownerState }) => {
			switch (ownerState.variant) {
				case 'small':
					return {
						width: '32px',
						height: '32px',
					};
				case 'large':
					return {
						width: '56px',
						height: '56px',
					};
				default:
					return {
						width: '40px',
						height: '40px',
					};
			}
		},
	},
};
